import { Divider, Switch, Typography } from '@neo4j-ndl/react';
import cn from 'classnames';
import type { JSX, PropsWithChildren } from 'react';
import React from 'react';

function ControlPanelComponent({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <section
      className={cn(
        'bg-palette-neutral-bg-weak border-palette-neutral-border-weak rounded-lg border border-solid',
        className,
      )}
    >
      {children}
    </section>
  );
}

function Content({
  title,
  children,
  titleRight,
}: PropsWithChildren<{ title?: string | JSX.Element; titleRight?: JSX.Element }>) {
  return (
    <div className="flex flex-col gap-8 p-8">
      {Boolean(title) && (
        <div className="flex flex-row items-center">
          {typeof title === 'string' ? (
            <Typography variant="h6" as="span">
              {title}
            </Typography>
          ) : (
            title
          )}
          {titleRight && <div className="ml-auto">{titleRight}</div>}
        </div>
      )}
      {children}
    </div>
  );
}

function Footer({ children }: PropsWithChildren) {
  return (
    <>
      <Divider orientation="horizontal" />
      <div className="flex justify-end gap-4 p-4">{children}</div>
    </>
  );
}

function ControlPanelSwitch({
  label,
  description,
  ...props
}: React.ComponentProps<typeof Switch> & { label: string; description: string | JSX.Element }) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row items-center gap-4">
        <Switch {...props} /> <Typography variant="subheading-small">{label}</Typography>
      </div>
      {typeof description === 'string' ? (
        <Typography variant="body-medium" className="text-palette-neutral-text-weaker ml-[52px]">
          {description}
        </Typography>
      ) : (
        description
      )}
    </div>
  );
}

export const ControlPanelNew = Object.assign(ControlPanelComponent, { Footer, Content, Switch: ControlPanelSwitch });
